var _g, _circle, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProButtonLeftInactive(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3456_2)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.8227 20.8351C18.6085 21.0522 18.254 21.0522 18.0398 20.8351L14.1624 16.9041C13.9483 16.687 13.9483 16.3276 14.1624 16.1104L18.0398 12.1795C18.2466 11.9549 18.6011 11.9399 18.8227 12.1495C19.0443 12.3592 19.059 12.7186 18.8522 12.9432C18.8449 12.9507 18.8375 12.9657 18.8227 12.9732L15.3367 16.5073L18.8227 20.0414C19.0369 20.2585 19.0369 20.6179 18.8227 20.8351Z",
    fill: "#A9A9A9"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16.5,
    cy: 16.5,
    r: 16,
    transform: "rotate(180 16.5 16.5)",
    stroke: "#A9A9A9"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3456_2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 5,
    height: 9,
    fill: "white",
    transform: "matrix(-1 0 0 -1 19 21)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProButtonLeftInactive);
export default __webpack_public_path__ + "static/media/pro-button-left-inactive.198cf63ebe7ac5bcc202f95d4157ea87.svg";
export { ForwardRef as ReactComponent };